import GlobalDispatcher from "../../events/GlobalDispatcher";
import DataProvider from "./SlotLocalData";
import BaseServerManager from "../../base/server/BaseServerManager";

export default class SlotServerManager extends BaseServerManager {
    constructor() {
        super();
    }

    addDataProvider() {
        this.dataProvider = new DataProvider();
    }

    addListeners() {
        GlobalDispatcher.add('rollingState:start', this.onStartSpin, this);
        GlobalDispatcher.add('model:init', this.onInit, this);
        GlobalDispatcher.add('dataProvider:hasResponse', this.onResponse, this);
    }

    onInit() {
        this.startTimeout();
    }

    onStartSpin() {
        this.startTimeout();
    }

    onResponse(data) {
        switch (data.params.action) {
            case 'init':
            case 'reconnect':
                this.hasInitData(data.params);
                break;
            case 'spin':
                this.hasSpinData(data.params);
                break;
        }
        this.stopTimeout();
    }

    hasInitData(data) {

    }

    hasSpinData(data) {

    }
}